import { Link } from "react-router-dom";

const ChooseRightCharter = () => {
    return (
        <section className="bg-primary">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-20 md:py-28">

                    <div className="text-center">

                        <p className="text-white/70 text-sm uppercase tracking-widest">
                            Travel Tips
                        </p>

                        <h1 className="mt-4 text-white text-4xl md:text-6xl font-bold max-w-5xl mx-auto leading-tight">
                            How To Choose The Right Charter Transportation For Your Group
                        </h1>

                        <div className="mt-8 flex flex-wrap justify-center gap-4 text-white/70">
                            <span>June 12, 2026</span>
                            <span>•</span>
                            <span>Velox Charter</span>
                        </div>

                    </div>

                </div>
            </div>

            <section className="bg-[#F9FAFB] py-16 lg:py-24">
                <div className="max-w-7xl mx-auto px-4">

                    <div className="grid lg:grid-cols-12 gap-10">
                        <div className="lg:col-span-8">

                            <div className="bg-white rounded-[30px] overflow-hidden shadow-sm">

                                <img
                                    src="/images/right-charter-group-van.png"
                                    alt="Choose The Right Charter Transportation"
                                    className="w-full h-[300px] md:h-[500px] object-cover"
                                />

                                <div className="p-8 md:p-12">
                                    <p className="text-[#666666] leading-8 text-lg">
                                        Planning transportation for a group can be
                                        challenging, especially when you're trying
                                        to balance comfort, budget, scheduling,
                                        and passenger needs. Whether you're
                                        organizing a corporate event, airport
                                        transfer, wedding, sporting event, or
                                        group tour, selecting the right charter
                                        transportation solution can make a
                                        significant difference in the overall
                                        experience.
                                    </p>

                                    <p className="mt-6 text-[#666666] leading-8 text-lg">
                                        With a variety of vehicle options
                                        available, understanding your group's
                                        specific requirements is the first step
                                        toward creating a safe, comfortable,
                                        and stress-free journey.
                                    </p>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            1. Determine Your Group Size
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            One of the most important factors when
                                            selecting charter transportation is
                                            knowing how many passengers will be
                                            traveling. Choosing the correct vehicle
                                            ensures everyone has enough space while
                                            helping you avoid unnecessary
                                            transportation costs.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Small Groups: Executive Sedans & SUVs</li>
                                            <li>✓ Medium Groups: Sprinter Vans</li>
                                            <li>✓ Large Groups: Mini Coaches</li>
                                            <li>✓ Very Large Groups: Charter Buses & Motor Coaches</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            2. Consider The Purpose Of The Trip
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Different events require different
                                            transportation solutions. Understanding
                                            the purpose of your trip helps determine
                                            which vehicle and amenities are most
                                            appropriate.
                                        </p>

                                        <div className="grid sm:grid-cols-2 gap-4 mt-6">
                                            {[
                                                "Corporate Meetings",
                                                "Airport Transfers",
                                                "Wedding Transportation",
                                                "Sporting Events",
                                            ].map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="bg-[#F8FAFC] border rounded-[16px] p-5"
                                                >
                                                    {item}
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            3. Evaluate Passenger Comfort
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Passenger comfort should always be a
                                            priority, especially for longer trips.
                                            Look for transportation options that
                                            provide spacious seating, climate
                                            control, luggage storage, and modern
                                            amenities that enhance the travel
                                            experience.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Comfortable passengers enjoy the
                                            journey more, resulting in a better
                                            overall travel experience for everyone.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            4. Review Luggage Requirements
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            If your group is traveling to or from
                                            an airport, attending a conference,
                                            or embarking on a multi-day trip,
                                            luggage capacity becomes an important
                                            consideration.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Make sure the selected vehicle has
                                            enough storage space to comfortably
                                            accommodate passengers and their
                                            belongings without compromising comfort.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            5. Prioritize Safety & Reliability
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Safety should never be compromised
                                            when choosing transportation. Select a
                                            provider that maintains a modern fleet,
                                            follows strict maintenance schedules,
                                            and employs professionally trained
                                            drivers.
                                        </p>

                                        <ul className="mt-5 space-y-3 text-[#666666]">
                                            <li>✓ Routine Vehicle Inspections</li>
                                            <li>✓ Professional Drivers</li>
                                            <li>✓ Safety Compliance Standards</li>
                                            <li>✓ Reliable Scheduling</li>
                                        </ul>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            6. Compare Vehicle Options
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Comparing multiple vehicle options
                                            allows you to find the right balance
                                            between passenger capacity, amenities,
                                            comfort, and budget.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Working with an experienced
                                            transportation provider can help you
                                            identify the best solution for your
                                            specific needs.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            7. Book Early Whenever Possible
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Popular travel dates and major events
                                            often result in limited vehicle
                                            availability. Booking early provides
                                            more vehicle choices, better scheduling
                                            flexibility, and additional peace of
                                            mind.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Early planning also allows time to
                                            coordinate schedules, passenger counts,
                                            pickup locations, and special requests.
                                        </p>
                                    </div>

                                    <div className="mt-12">
                                        <h2 className="text-3xl font-semibold">
                                            Final Thoughts
                                        </h2>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            Choosing the right charter
                                            transportation involves more than
                                            simply selecting a vehicle. Group size,
                                            travel purpose, comfort, luggage
                                            requirements, safety, and scheduling
                                            all play an important role in creating
                                            a successful transportation experience.
                                        </p>

                                        <p className="mt-5 text-[#666666] leading-8">
                                            By taking the time to evaluate your
                                            needs and work with a trusted
                                            transportation provider, you can ensure
                                            a smooth, reliable, and comfortable
                                            journey for every passenger.
                                        </p>
                                    </div>

                                </div>

                            </div>

                        </div>

                        <div className="lg:col-span-4">

                            <div className="sticky top-6">

                                <div className="bg-primary rounded-[24px] p-8 text-center">

                                    <h3 className="text-white text-2xl font-semibold">
                                        Need Help Choosing The Right Vehicle?
                                    </h3>

                                    <p className="mt-4 text-white/80 leading-7">
                                        Our transportation specialists can help
                                        you find the perfect vehicle for your
                                        group size, schedule, and destination.
                                    </p>

                                    <Link
                                        to="/contact-us"
                                        className="mt-4 inline-block bg-white text-primary px-8 py-4 rounded-full font-semibold hover:scale-105 transition-all"
                                    >
                                        Contact Us
                                    </Link>
                                </div>

                                <div className="bg-white rounded-[24px] p-8 mt-8">

                                    <h3 className="text-2xl font-semibold">
                                        Quick Tips
                                    </h3>

                                    <div className="mt-6 space-y-4 text-[#666666]">

                                        <p>✓ Confirm passenger count early</p>
                                        <p>✓ Consider luggage requirements</p>
                                        <p>✓ Prioritize passenger comfort</p>
                                        <p>✓ Review safety standards</p>
                                        <p>✓ Book transportation in advance</p>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>

        </section>
    );
};

export default ChooseRightCharter;